import React from 'react';
import { Button, Form, FormGroup, Label, Input } from '../Bootstrap';
import { AuthService, AuthTokenResponse } from '../../AuthService';
import { useInputState } from '../../hooks';
const Logo = require('./Logo.svg');

interface LoginFormProps {
  onLogin(data: { email: string; password: string }, authTokenResponse: AuthTokenResponse);
  email: string;
  auth: AuthService;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onLogin, email: initialEmail, auth }) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<Error | null>(null);
  const [email, setEmail] = useInputState(initialEmail ?? '');
  const [password, setPassword] = useInputState('');
  const onSubmit: React.FormEventHandler<HTMLFormElement> = React.useCallback(
    async (e) => {
      e.preventDefault();

      setLoading(true);
      setError(null);
      try {
        const response = await auth.login(email, password);
        onLogin({ email, password }, response);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    },
    [email, password, setLoading, setError, auth, onLogin]
  );

  return (
    <div>
      <div className='text-center mt-2 mb-3'>
        <img src={Logo} />
      </div>
      <p className='text-center text-danger'>{error && 'Bad email or password.'}</p>
      <Form onSubmit={onSubmit} className='slim'>
        <FormGroup>
          <Label for='login-email'>Email</Label>
          <Input
            disabled={!!initialEmail}
            id='login-email'
            type='email'
            autocomplete='off'
            value={email}
            onChange={setEmail}
          />
        </FormGroup>
        <FormGroup>
          <Label for='login-password'>Password</Label>
          <Input id='login-password' type='password' autocomplete='off' value={password} onChange={setPassword} />
        </FormGroup>
        <div className='mt-3 text-center'>
          <Button disabled={loading} type='submit' color='primary' className='btn--rounded-padded'>
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </div>
      </Form>
      <div>
        <a className='onboarding-forogot-password' href='/forgot-password'>
          Forgot Password
        </a>
      </div>
    </div>
  );
};
